module.exports = __webpack_public_path__ + "static/media/pizzeria profilo.9b9f6c8d.svg";